var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216.827,
    height: 203.511,
    viewBox: "0 0 216.827 203.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(-47.242 -96.777)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M458.512-621.929c30.259,9.016,62.262,9.185,93.552,8.232,19.306-.588,39.08-.226,58.168-3.477,11.335-1.93,36.467-4.795,37.779-20.086.85-9.918-11.139-15.224-18.763-17.88-12.319-4.293-25.07-6.369-38.006-7.748-21.032-2.246-42.706-2.621-63.9-2.88-18.4-.227-36.814.4-55.026,3.2-11.715,1.8-25.616,4.89-34.623,13.3a29.829,29.829,0,0,0-2.626,2.779c-5.516,6.649-5.517,13.635,2.772,17.9,6.011,3.1,14.168,4.729,20.669,6.665",
    transform: "translate(-383.985 913.599)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M519.8-596.84l-1.2-.3c-.792-.205-1.973-.487-3.515-.852s-3.447-.8-5.674-1.379a64.1,64.1,0,0,1-7.556-2.359,19.17,19.17,0,0,1-4.188-2.153,8.54,8.54,0,0,1-3.271-4.057,7.67,7.67,0,0,1,.443-5.661,11.642,11.642,0,0,1,.7-1.33l.4-.651.453-.624c.3-.434.629-.8.954-1.192l.246-.292.281-.295.549-.569a32.072,32.072,0,0,1,5.021-4.072,45.412,45.412,0,0,1,6.039-3.226,70.994,70.994,0,0,1,14.031-4.323c2.5-.523,5.071-.973,7.69-1.376s5.3-.664,8.024-1.011l4.122-.49,2.088-.234,2.111-.144,8.6-.582q1.091-.075,2.189-.147l2.208-.069,4.459-.138c2.99-.079,6.024-.23,9.07-.2l9.247-.021c3.142.007,6.266.1,9.442.142,6.34.079,12.791.309,19.318.49,3.264.084,6.554.3,9.856.453,3.3.189,6.631.265,9.941.594l9.985.833c3.368.271,6.7.685,10.056,1.1a169.52,169.52,0,0,1,19.976,3.758c1.646.432,3.3.844,4.908,1.354l2.427.729c.827.261,1.62.529,2.426.815a42.451,42.451,0,0,1,9.208,4.386,17.914,17.914,0,0,1,3.889,3.358,9.731,9.731,0,0,1,2.227,4.661l.081.652.023.667c.009.224-.018.422-.025.635a4.641,4.641,0,0,1-.073.651,8.279,8.279,0,0,1-.254,1.269l-.173.625c-.065.207-.157.4-.235.6a12.013,12.013,0,0,1-2.919,4.185,26.259,26.259,0,0,1-8.644,5.044,65.389,65.389,0,0,1-9.506,2.721c-3.2.695-6.413,1.208-9.594,1.722l-4.752.74-4.74.679c-6.306.806-12.54,1.346-18.645,1.65-3.053.188-6.072.292-9.056.406q-4.472.11-8.833.217c-11.608.245-22.6.635-32.763.5s-19.469-.547-27.689-1.31l-5.962-.554c-.961-.072-1.9-.211-2.818-.337l-2.707-.368c-3.536-.494-6.793-.871-9.7-1.461l-7.776-1.417-5.682-1.338Zm.051-.2,4.734,1.092,5.688,1.312c2.257.419,4.867.815,7.78,1.306,1.461.221,2.984.545,4.613.692l5.093.55,2.708.292c.921.1,1.858.213,2.819.258l5.959.386c4.1.337,8.484.356,13.094.514,2.3.1,4.674.029,7.1.051l3.675,0c1.239.013,2.491.013,3.757-.018,10.124-.1,21.1-.5,32.727-.629,11.612-.236,23.862-.221,36.435-1.6l4.724-.566,4.771-.633c3.187-.422,6.382-.926,9.565-1.582a64.693,64.693,0,0,0,9.422-2.606,24.364,24.364,0,0,0,8.44-4.864,11.338,11.338,0,0,0,2.732-3.969c.07-.188.157-.372.215-.564l.158-.583a7.766,7.766,0,0,0,.227-1.189,3.7,3.7,0,0,0,.065-.6c.006-.205.032-.425.021-.619l-.025-.588-.078-.6a9,9,0,0,0-2.095-4.293,17.2,17.2,0,0,0-3.744-3.187c-5.654-3.54-12.316-5.2-18.818-6.822a168.819,168.819,0,0,0-19.891-3.314c-3.33-.369-6.68-.737-9.994-.957l-10-.695c-3.322-.274-6.621-.339-9.909-.5-3.288-.12-6.549-.314-9.809-.371-6.516-.129-12.948-.309-19.286-.337l-9.407-.094-9.247-.007c-3.056-.041-6.053.1-9.023.17l-4.426.123-2.192.062q-1.09.068-2.174.139l-8.547.553-2.1.135-2.072.227q-2.065.216-4.1.427c-2.707.295-5.378.506-7.984.856s-5.139.746-7.613,1.217a75.233,75.233,0,0,0-13.85,3.851,44.16,44.16,0,0,0-5.956,2.946,30.221,30.221,0,0,0-4.976,3.8l-.535.525-.255.249-.254.284a14.4,14.4,0,0,0-.961,1.133l-.438.569-.389.6a10.92,10.92,0,0,0-.69,1.228,6.964,6.964,0,0,0-.56,5.141,8,8,0,0,0,2.961,3.867A18.835,18.835,0,0,0,502-602.1a59.308,59.308,0,0,0,7.474,2.454c2.218.588,4.119,1.041,5.659,1.414s2.721.664,3.513.875l1.2.309",
    transform: "translate(-439.885 885.805)",
    fill: "#797b98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M963.711-612.909c0,2.751-2.23,2.155-4.981,2.155s-4.98.6-4.98-2.155v-25.643a4.98,4.98,0,0,1,4.98-4.979c2.751,0,10.491,2.229,10.491,4.979l-5.51,25.643",
    transform: "translate(-848.96 893.769)",
    fill: "#875248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M1745.772-612.909c0,2.751,2.229,2.155,4.981,2.155s4.979.6,4.979-2.155v-25.643a4.98,4.98,0,0,0-4.979-4.979c-2.751,0-10.491,2.229-10.491,4.979l5.51,25.643",
    transform: "translate(-1549.054 893.769)",
    fill: "#875248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M1600.546-728.576c0,2.751,2.23,2.156,4.98,2.156s4.981.6,4.981-2.156v-25.643a4.98,4.98,0,0,0-4.981-4.979c-2.75,0-10.489,2.229-10.489,4.979l5.51,25.643",
    transform: "translate(-1419.785 996.75)",
    fill: "#875248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M1108.931-728.576c0,2.751-2.23,2.156-4.98,2.156s-4.981.6-4.981-2.156v-25.643a4.98,4.98,0,0,1,4.981-4.979c2.75,0,10.49,2.229,10.49,4.979l-5.51,25.643",
    transform: "translate(-978.223 996.75)",
    fill: "#875248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M1091.321-828.166c0,5.013-4.554,9.078-10.173,9.078H1009.94c-5.618,0-10.173-4.065-10.173-9.078v-3.025c0-5.015-1.379-17.967,4.239-17.967l83.075.378c5.618,0,4.239,12.574,4.239,17.588v3.025",
    transform: "translate(-889.81 1076.828)",
    fill: "#9e7d6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M1125.615-1392.169c0,5.013-6.25,9.078-11.869,9.078H1055.82c-5.618,0-12.433-4.065-12.433-9.078l2.26-33.537c0-11.728,4.555-14.625,10.173-14.625h57.926c5.619,0,10.173,2.684,10.173,14.625l1.7,33.537",
    transform: "translate(-928.767 1603.037)",
    fill: "#c49d8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M1092.532-929.092c0,5.013-4.554,9.078-10.173,9.078h-71.207c-5.618,0-10.173-4.065-10.173-9.078v-3.025c0-5.015,4.342-18.534,9.961-18.534l72.268.19c5.617,0,9.324,13.329,9.324,18.343v3.025",
    transform: "translate(-891.022 1167.169)",
    fill: "#7e6356"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M821.612-1139.6c-1.444-5.025-9.833-11.747-15.906-7.886-3.543,2.253-23.454,22.906-24.219,24.969-3.491,9.418,14.324,14.607,22.889,13.427,4.634-.638,19.656-22.09,17.236-30.51",
    transform: "translate(-695.229 1343.398)",
    fill: "#9e7d6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M1682.515-1139.6c1.445-5.025,9.833-11.747,15.907-7.886,3.543,2.253,23.453,22.906,24.218,24.969,3.492,9.418-14.324,14.607-22.889,13.427-4.635-.638-19.657-22.09-17.237-30.51",
    transform: "translate(-1497.429 1343.398)",
    fill: "#9e7d6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M898.524-942.7c-5.6-.619-11.681,1.589-15.066,5.548-5.2,6.083-3.879,12.112-5.076,19.208-1.787,10.6-12.9,11.309-23.308,11.743-3.716.154-7.679.136-11.549.334-11.3-.2-25.824-.179-29.56-.334-10.412-.434-21.519-1.148-23.309-11.743-1.2-7.1.123-13.125-5.075-19.208-3.385-3.959-9.467-6.167-15.066-5.548-6.2.685-8.356,8.8-7.935,13.037a38.574,38.574,0,0,0,5.958,17.461c10.813,16.6,23.661,16.529,55.177,16.571,1.337,0,8.073.072,15.4-.056,3.281.042,5.585.057,6.212.056,31.518-.043,44.365.028,55.178-16.571a38.559,38.559,0,0,0,5.957-17.461c.422-4.241-1.731-12.353-7.935-13.037",
    transform: "translate(-678.788 1160.174)",
    fill: "#c49d8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M1452.129-968.635l-13.975-15.313c-.336-2.765-4.211,3.533-8.228,4.022s-6.769,8.385-6.433,11.149l14.1,8.832,14.532-8.689",
    transform: "translate(-1267.068 1197.433)",
    fill: "#172d49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M1135.75-968.635l13.977-15.313c.335-2.765,4.211,3.533,8.227,4.022s6.771,8.385,6.435,11.149l-14.105,8.832-14.533-8.689",
    transform: "translate(-1010.965 1197.433)",
    fill: "#172d49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M1265.167-977.011s-1.147,15.9,16.464,15.731c16.463-.161,15.16-15.731,15.16-15.731h-31.624",
    transform: "translate(-1126.151 1190.639)",
    fill: "#172d49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M1525.486-758.754c3.207.877,4.99,4.72,4.063,8.1s-4.361,5.8-7.567,4.916l-13.483-4.1c-3.207-.878-3.565-3.925-2.638-7.307s2.786-5.822,5.994-4.944l13.631,3.33",
    transform: "translate(-1340.015 999.488)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M1511.885-756.633a6.02,6.02,0,0,1,4.216,7.4,6.021,6.021,0,0,1-7.4,4.216l-12.076-3.308a6.019,6.019,0,0,1-4.216-7.4,6.019,6.019,0,0,1,7.4-4.214l12.077,3.308",
    transform: "translate(-1328.248 997.612)",
    fill: "#da4c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M1436.083-763.093c2.01.55,4.081,3.326,3.531,5.337s-3.781,3.458-5.79,2.907l-7.1-2.467c-2.01-.55-2.806-2.52-2.256-4.528s2.24-3.3,4.248-2.748l7.372,1.5",
    transform: "translate(-1267.803 1001.677)",
    fill: "#f6876b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M1507.029-740.343a2.831,2.831,0,0,1,1.982,3.477,2.829,2.829,0,0,1-3.477,1.98l-2.159-.092c-1.507-.412-1.917-2.338-1.506-3.845s1.911-3.1,3.418-2.684l1.741,1.164",
    transform: "translate(-1336.718 981.073)",
    fill: "#da4c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M1553.54-734.047a.723.723,0,0,1,.506.887l-1.574,5.749a.723.723,0,0,1-.888.5.719.719,0,0,1-.5-.885l1.573-5.749a.724.724,0,0,1,.888-.506",
    transform: "translate(-1380.63 974.398)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M1571.49-729.128a.725.725,0,0,1,.506.89l-1.574,5.746a.722.722,0,0,1-.888.506.722.722,0,0,1-.506-.887l1.574-5.749a.723.723,0,0,1,.888-.506",
    transform: "translate(-1396.606 970.018)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M1589.972-724.061a.723.723,0,0,1,.509.887l-1.576,5.749a.722.722,0,0,1-.887.5.722.722,0,0,1-.507-.887l1.574-5.747a.723.723,0,0,1,.887-.506",
    transform: "translate(-1413.059 965.508)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M1607.929-719.146a.722.722,0,0,1,.506.888l-1.574,5.747a.724.724,0,0,1-.888.506.723.723,0,0,1-.506-.888l1.574-5.747a.72.72,0,0,1,.888-.506",
    transform: "translate(-1429.042 961.134)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M1154.465-835.24c2.609.714,3.194-1.4,3.908-4.008s1.288-4.726-1.321-5.441l-34.327-9.565c-2.609-.714-5.179,1.881-6.022,5.372,0,0-1.494,7.907,3.387,9.113,12.009,2.965,34.374,4.528,34.374,4.528",
    transform: "translate(-993.824 1081.473)",
    fill: "#172d49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M1115.22-714.909c-3.24.749-6.632-1.788-7.422-5.205s1.089-7.171,4.329-7.917l13.813-2.789c3.24-.749,5,1.763,5.789,5.18s.31,6.447-2.931,7.2l-13.578,3.536",
    transform: "translate(-985.924 971.617)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M1130.689-713.941a6.018,6.018,0,0,1-7.219-4.509,6.017,6.017,0,0,1,4.51-7.219l12.2-2.819a6.018,6.018,0,0,1,7.22,4.51,6.017,6.017,0,0,1-4.51,7.219l-12.2,2.817",
    transform: "translate(-999.894 969.562)",
    fill: "#da4c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M1277.57-719.894c-2.029.469-5.17-.991-5.64-3.022s1.688-4.837,3.718-5.306l7.425-1.2c2.029-.471,3.665.885,4.132,2.915s-.4,3.968-2.435,4.434l-7.2,2.178",
    transform: "translate(-1132.122 970.34)",
    fill: "#f6876b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M1270.146-703.125a2.828,2.828,0,0,1-3.395-2.118,2.832,2.832,0,0,1,2.12-3.395l1.944-.943c1.522-.353,2.8,1.149,3.15,2.672s-.214,3.632-1.736,3.984l-2.084-.2",
    transform: "translate(-1127.503 952.643)",
    fill: "#da4c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M1261.008-694.724a.725.725,0,0,1-.867-.541l-1.34-5.808a.722.722,0,0,1,.542-.866.721.721,0,0,1,.865.539l1.342,5.809a.725.725,0,0,1-.541.866",
    transform: "translate(-1120.472 945.812)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "M1242.862-690.534a.724.724,0,0,1-.866-.544l-1.342-5.8a.723.723,0,0,1,.542-.866.722.722,0,0,1,.866.541l1.341,5.806a.723.723,0,0,1-.542.868",
    transform: "translate(-1104.32 942.081)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M1224.187-686.221a.719.719,0,0,1-.867-.538l-1.342-5.808a.722.722,0,0,1,.542-.866.722.722,0,0,1,.867.542l1.341,5.8a.72.72,0,0,1-.541.865",
    transform: "translate(-1087.696 938.239)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M1206.05-682.029a.722.722,0,0,1-.866-.539l-1.341-5.808a.722.722,0,0,1,.542-.866.721.721,0,0,1,.866.539l1.342,5.808a.723.723,0,0,1-.542.866",
    transform: "translate(-1071.552 934.51)",
    fill: "#cccbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M1335.667-837.144c-2.636.608-2.149,2.745-1.54,5.381s1.108,4.774,3.744,4.164l34.756-7.867c2.635-.61,3.666-4.113,2.751-7.587,0,0-2.434-7.666-7.306-6.413-11.977,3.086-32.406,12.322-32.406,12.322",
    transform: "translate(-1187.124 1077.228)",
    fill: "#172d49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M1169.243-1441.663s-8.347-.642-10.755,3.049-8.99,16.857-8.99,16.857,7.224,5.778,10.594,5.3c1.607-3.049,9.15-25.2,9.15-25.2",
    transform: "translate(-1023.201 1604.273)",
    fill: "#434db8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M1504.33-1441.663s8.347-.642,10.755,3.049,8.99,16.857,8.99,16.857-7.224,5.778-10.6,5.3c-1.6-3.049-9.148-25.2-9.148-25.2",
    transform: "translate(-1339.046 1604.273)",
    fill: "#434db8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M1261.519-1444.977s-12.361-.482-12.039,12.039,1.926,37.242,1.926,37.242a20.252,20.252,0,0,0,15.249,6.9c10.114.16,17.818-7.064,17.818-7.064l1.607-35.155s2.568-13.646-12.521-13.805c-16.542-.174-12.04-.16-12.04-.16",
    transform: "translate(-1112.197 1607.176)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M1109.463-1249.157l-6.612,16.948c-.646,1.655.638,3.7,2.868,4.57s4.561.235,5.206-1.42l6.275-16.082c-2.422-.435-5.767-2.608-7.737-4.016",
    transform: "translate(-981.528 1432.882)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M1131.584-1109.166c1.445,1.033,2.2,2.134.884,3.974-.6,1.066-2.885,1.319-4.331.286l-22.465-14.414c-1.443-1.035-1.55-3.363-.234-5.2s3.554-2.492,5-1.458l21.149,16.813",
    transform: "translate(-983.163 1323.674)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M1314.236-979.78c.176.022.349.05.516.083a15.328,15.328,0,0,1,2.322.6c.39.147,1.293.733.882,1.283-.233.309-.607.109-.931.073a3.972,3.972,0,0,0-2.3.4c.232.44,1.159.724,1.59.932.683.331,1.4.66,2.1.97,1.161.52,2.077.806,2.337,2.118a2.878,2.878,0,0,1-1.538,3.181c-1.677.894-3.914-.869-5.3-1.585a17.257,17.257,0,0,1-4.564-3.056,3.06,3.06,0,0,1,.125-4.019,2.726,2.726,0,0,1,2.271-1.123c.786.059,1.67.05,2.488.15",
    transform: "translate(-1164.866 1193.245)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M1615.593-1234.107l-6.508-16.677c-1.85,1.34-5.186,3.562-7.688,4.14l6.121,15.687c.645,1.655,2.976,2.291,5.207,1.42s3.515-2.915,2.869-4.57",
    transform: "translate(-1425.445 1434.33)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M1471.334-1113.265c-1.445,1.033-2.2,2.134-.884,3.974.6,1.064,2.886,1.319,4.331.284l22.465-14.412c1.442-1.035,1.549-3.362.234-5.2s-3.554-2.494-5-1.458l-21.149,16.813",
    transform: "translate(-1308.286 1327.323)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M1422.02-983.883c-.176.022-.349.05-.517.084a15.1,15.1,0,0,0-2.32.6c-.391.147-1.293.734-.884,1.283.235.311.608.11.932.073a3.975,3.975,0,0,1,2.3.4c-.231.44-1.159.724-1.589.932-.685.33-1.4.658-2.1.97-1.162.52-2.076.8-2.336,2.118a2.875,2.875,0,0,0,1.538,3.181c1.677.894,3.914-.869,5.3-1.586a17.262,17.262,0,0,0,4.564-3.056,3.06,3.06,0,0,0-.127-4.019,2.727,2.727,0,0,0-2.269-1.123c-.786.06-1.671.051-2.488.151",
    transform: "translate(-1259.92 1196.898)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M1371.863-1490.92c0,3.045-2.766,5.513-6.178,5.513s-6.181-2.468-6.181-5.513l.959-6.311c0-3.044,1.809-5.432,5.223-5.432s5.211,2.548,5.211,5.592l.967,6.151",
    transform: "translate(-1210.13 1658.536)",
    fill: "#d9967b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M1322.585-1724.817c0,9.06-2.432,16.4-13.125,16.4-11.082,0-13.124-7.344-13.124-16.4s5.876-16.406,13.124-16.406,13.125,7.345,13.125,16.406",
    transform: "translate(-1153.906 1870.88)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M1275.278-1626a3.1,3.1,0,0,1-3.062,3.135,3.1,3.1,0,0,1-3.062-3.135,3.1,3.1,0,0,1,3.062-3.134,3.1,3.1,0,0,1,3.062,3.134",
    transform: "translate(-1129.706 1771.11)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M1512.707-1626a3.1,3.1,0,0,1-3.062,3.135,3.1,3.1,0,0,1-3.062-3.135,3.1,3.1,0,0,1,3.062-3.134,3.1,3.1,0,0,1,3.062,3.134",
    transform: "translate(-1341.047 1771.11)",
    fill: "#eea687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M1313.548-1763.952c.054-1.1,1.454-2.362.7-3.543.13.208.8.391,1.02.668a3.56,3.56,0,0,1,.556,1.215,10.188,10.188,0,0,1,.284,3.761c-.053.57-.549,1.8.1,2.2.843.52,1.422-.482,1.42-1.145-.006-1.636-.169-3.58.539-5.1.7-1.505,1.294-3.421.695-5.029-.765-2.045-3.14-3-4.626-4.465-1.7-1.672-1.862-4.359-4.206-5.453a5.8,5.8,0,0,0-5.237.161,14.414,14.414,0,0,1-6.19,1.151c-1.12,0-2.194-.185-3.315-.219a3.935,3.935,0,0,0-3.112,1.413c-.907,1.067-.846,2.241-.97,3.553-.227,2.383-.478,4.771-.515,7.168a31.863,31.863,0,0,0,.137,3.644c.1,1.01.336,2.1.334,3.106,0,.639-.137,1.1.728,1.094a.967.967,0,0,0,1.021-.962c.124-.988-.37-1.9-.353-2.879a3.809,3.809,0,0,1,1.309-2.706,32.841,32.841,0,0,0,2.658-2.405,5.274,5.274,0,0,0,1.157-2.91c.446.932,2.054,1.821,2.977,2.29a16.068,16.068,0,0,0,6.083,1.557c2.416.114,7.117.545,6.806,3.839",
    transform: "translate(-1148.878 1906.646)",
    fill: "#4e261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M1210.6-1218.225a5.885,5.885,0,0,1-5.884,5.885h-39.232a5.886,5.886,0,0,1-5.885-5.885l-3.187-31.14a5.885,5.885,0,0,1,5.884-5.885h45.607a5.886,5.886,0,0,1,5.885,5.885l-3.188,31.14",
    transform: "translate(-1029.368 1438.297)",
    fill: "#191b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M1387.7-1100.563a4.179,4.179,0,0,1-4.181,4.179,4.178,4.178,0,0,1-4.179-4.179,4.179,4.179,0,0,1,4.179-4.18,4.18,4.18,0,0,1,4.181,4.18",
    transform: "translate(-1227.788 1304.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M1231.192-875.867a2.452,2.452,0,0,1-2.452,2.452h-47.568a2.452,2.452,0,0,1-2.452-2.452,2.452,2.452,0,0,1,2.452-2.451h47.568a2.452,2.452,0,0,1,2.452,2.451",
    transform: "translate(-1049.221 1102.794)",
    fill: "#0f0f0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M905.487-1314.671a4.057,4.057,0,0,0-.047,2.177c.558,2,1.826,3.361-.263,5.015,1.3-1.139.184-2.473-.628-3.4-.91-1.041-1.906-1.973-1.634-3.5.441-2.486,3.627-5.336.975-7.719,1.506.323,2.264,2.3,2.415,3.632.153,1.349-.492,2.549-.816,3.8",
    transform: "translate(-803.665 1497.816)",
    fill: "#faf9e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M944.97-1262.79a2.693,2.693,0,0,0-.032,1.445c.37,1.322,1.211,2.227-.175,3.323.862-.756.122-1.639-.416-2.254-.6-.69-1.265-1.307-1.084-2.323.292-1.648,2.4-3.537.646-5.117,1,.212,1.5,1.527,1.6,2.408a6.9,6.9,0,0,1-.541,2.518",
    transform: "translate(-839.595 1449.406)",
    fill: "#faf9e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M972.187-1152.944a4.491,4.491,0,0,1-4.708,4.239H966.04a4.492,4.492,0,0,1-4.709-4.239v-3.294a4.493,4.493,0,0,1,4.709-4.239h1.439a4.492,4.492,0,0,1,4.708,4.239Zm-3.849-8.653h-1.713a5.347,5.347,0,0,0-5.605,5.044v3.924a5.346,5.346,0,0,0,5.605,5.044h1.713a5.346,5.346,0,0,0,5.6-5.044v-3.924a5.347,5.347,0,0,0-5.6-5.044",
    transform: "translate(-855.429 1354.945)",
    fill: "#c52631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M893.358-1157.323h-14.48v-18.448h14.48v18.448",
    transform: "translate(-782.313 1367.559)",
    fill: "#e12c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M885.774-1012.841H868.958v-1.743h16.816v1.743",
    transform: "translate(-773.483 1224.089)",
    fill: "#c52631"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8389",
    "data-name": "Group 8389",
    transform: "translate(-6.265 -0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M1595.988-2164.908h-7.7l-3.922-32.86h15.638",
    transform: "translate(-1397.34 2294.564)",
    fill: "#a5a4d9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(190 132)",
    fill: "#a5a4d9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickStart);
export default __webpack_public_path__ + "static/media/QuickStart.80dc44e6ead935038dc9054a8bc13c4b.svg";
export { ForwardRef as ReactComponent };